import React, { useState, useEffect } from 'react';
import './auth.css';
import { useDispatch } from 'react-redux';
import { authSubmitSagaAction } from "../../redux/sagaActions";

const Auth = () => {
    const dispatch = useDispatch();
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');

    // Отправка формы авторизации
    const submit = () => {
        dispatch(authSubmitSagaAction({ phone, password }));
    };


    // Обработка нажатия клавиш
    const keydownHandler = event => {

        // Отправка формы при нажатии на Enter
        if (event.code === 'Enter') {
            submit();
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', keydownHandler);

        return () => document.removeEventListener('keydown', keydownHandler);
    }, [phone, password]);

    return (
        <div className="auth__wrapper">
            <div className="auth__scrollable">
                <div className="auth">
                    <i className="auth__logo" />
                    <div className="auth__form">
                        <input
                            type="text"
                            className="auth__input auth__input--phone"
                            placeholder={ 'Номер телефона' }
                            value={ phone }
                            onInput={ event => setPhone(event.target.value) }
                        />
                        <input
                            type="password"
                            className="auth__input auth__input--password"
                            placeholder={ 'Пароль' }
                            value={ password }
                            onInput={ event => setPassword(event.target.value) }
                        />
                        <i className="auth__submit" onClick={ submit } />
                    </div>
                    {/*<div className="auth__guest"*/}
                    {/*    onClick={ () => {*/}
                    {/*        dispatch(authSubmitSagaAction({ phone: '+375 (29) 000-00-00', password: 'test' }));*/}
                    {/*    } }*/}
                    {/*>Войти как гость</div>*/}
                </div>
            </div>
        </div>
    );
};

export default Auth;